<style lang="scss" type="text/scss">
    @import "assets/scss/base.scss";
    @import "assets/scss/init.scss";
    .distpicker-address-wrapper select{
        width:100px;
    }
    .yu-form-item .yu-form-item-label {
        padding: 7px 12px 7px 0;
    }
    .yu-form-item-content{
        line-height:28px;    
    }
    #app{
        width: 100%;
        height: 100%;
        // background: #f3f3f3;
        min-width: 1200px;
    }
    .breadnav{
        padding:20px 0;
    }
    .tonglu_picker{
    input{
        background: #fff;
        border:1px solid #E9E9E9;
        border-radius: 4px;
        width:180px;
        height:28px;
        padding:0 10px;
    }
    input::placeholder{
        color: #a8a8a8!important;
        font-size: 14px!important;
    }
    }

</style>

<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
    export default {
        name: 'app'
    }
</script>
<style lang="scss">
.mint-msgbox{
    overflow:initial
}
.modalauto {
    .autocomplete{
        right:0
    }
    input{
        width:300px;
    }
}

.form_textarea{
    outline:none;
}
.form_input,.form_select{
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    height:28px;
    &:hover{
        border: 1px solid #E9E9E9;
    };
    &:focus{
         border: 1px solid #E9E9E9;
    }
}
.downlink{
    color: #489EFE;
}
.yu-form-item-error .form-item {
    border: 1px solid #ff5959 !important;
}
.i_normal {
    width: 200px!important
}
.yu-radio{
    margin-right:20px;
}
.remove_btn{
    font-size:14px;
    margin-right:50px;
    cursor: pointer;
}
.distpicker-address-wrapper select{
    height:28px;
    font-size:14px;
    &:focus{
        outline:none;
    }
}
.autocomplete{
    min-width: 160px;
}
.yu_tooltip .tooltip {
    color: #4C4C4C;;
    padding: 8px 15px;
    font-size: 14px;
    line-height: 20px;
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
    .arrow{
            border-color: #E9E9E9 transparent transparent !important;
            &:after{
                bottom: 1px;
                margin-left: -6px;
                content: " ";
                border-width: 6px;
                 border-bottom-width: 0;
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                border-color: transparent;
                border-top-color: #fff;
                border-style: solid;
            }
    }
}
.i_max {
    width:310px !important;
}
.datepicker>input{
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    height: 28px;
    outline: none;
}
.con_item{
        margin-top:20px;
        background: #FFFFFF;
        border: 1px solid #E9E9E9;
        border-radius: 4px;
        padding:10px 0 20px 30px;
        .info_list{
            padding:20px 0;
        }
        .title{
            line-height:52px;
            font-size: 16px;
            color: #212121;
            border-bottom:1px solid #E9E9E9;
        }
        .row:after{
            content:""; 
            display: block; 
            clear:both; 
        }
        .col5{
            width:50%;
            float:left;
            font-size: 14px;
            color: #212121;
            line-height: 36px;
            .keyname{
                display: inline-block;
                text-align: right;
                width:120px;
            }
        }
        .small_title{
            line-height:52px;
            font-size: 16px;
            color: #212121;
            padding-left:28px;
            .tagbtn{
                font-size: 12px;
                padding:2px 8px;
                border-radius: 16px;
                border:1px solid #FFCE00;
                vertical-align: top;
                margin-left:10px;
            }
        }
    }
    .nolabel{
        .yu-form-item-content{
            margin-left:0px !important;
        }
    }
</style>




// WEBPACK FOOTER //
// src/App.vue